/* eslint-disable */
/**
 * ESLint is disabled here since type checking is hard with this kind of code
 * TODO: Should still be possible, refactor any to unknown,... later
 */
import { Camelizer } from './Camelizer'
import { StringUtils } from './StringUtils'

export class SerializationHelper {
  public static toInstance (obj: any, json: any, options: {idName: string} = {idName: ''}) {
    let jsonObj: any
    if (typeof (json) === 'string') {
      jsonObj = JSON.parse(json)
    } else {
      jsonObj = json
    }

    if (!jsonObj) {
      return null
    }

    // for legacy db id problem, add .[table_name_id] as .id
    if (!options.idName) {
      options.idName = obj.constructor.name
    }
    const snakeCaseId = StringUtils.toSnakeCase(options.idName.split('_')[0]) + `_id` 
    if (jsonObj.hasOwnProperty(snakeCaseId)) {
      if (obj.hasOwnProperty(`id`)) {
        obj.id = jsonObj[snakeCaseId]
      }
    }

    // for custom id name
    if (obj.constructor.idKey) {
      if (obj.hasOwnProperty(`id`)) {
        if (jsonObj.hasOwnProperty(obj.constructor.idKey)) {
          obj.id = jsonObj[obj.constructor.idKey]
        }
      }
    }

    // Convert all keys to camel case, e.g. form_type => formType
    Object.keys(jsonObj).forEach((k) => {
      const camelized = Camelizer.camelize(k)
      if (camelized !== k) {
        jsonObj[camelized] = jsonObj[k]
        delete jsonObj[k]
      }
    })

    if (typeof obj.fromJSON === 'function') {
      obj.fromJSON(jsonObj)
    } else {
      for (const propName in jsonObj) {
        if (obj.hasOwnProperty(propName)) {
          obj[propName] = jsonObj[propName]
        }
      }
    }

    return obj
  }

  public static toInstanceArray (Obj: any, json: any, options: {idName: string} = {idName: ''}) {
    const instances: Array<any> = []
    json.forEach((jsonObject: any) => {
      instances.push(this.toInstance(new Obj(), jsonObject, options))
    })
    return instances
  }
}
